/** Human-readable label for a video meeting URL. */
export function getVideoMeetingPlatformLabel(link: string): string {
  const url = link.toLowerCase();
  if (url.includes('meet.google.com')) return 'Google Meet';
  if (url.includes('zoom.us')) return 'Zoom';
  if (url.includes('teams.microsoft.com') || url.includes('teams.live.com')) return 'Microsoft Teams';
  return 'Video meeting';
}
